export const zIndex = {
  underlay: -1,
  overlay: 1,
  fixed: 3,
  curtain: 4,
}
